import { render, staticRenderFns } from "./CourseBanner.vue?vue&type=template&id=71f17bcc&"
import script from "./CourseBanner.vue?vue&type=script&lang=js&"
export * from "./CourseBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports